import { render, staticRenderFns } from "./ledger-select.vue?vue&type=template&id=3922f40c&lang=html&"
import script from "./ledger-select.vue?vue&type=script&lang=js&"
export * from "./ledger-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports